var _defs, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 15,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "geo-alt-fill"), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125,11.56201c-2.01929,0 -3.65625,-1.63696 -3.65625,-3.65625c0,-2.01929 1.63696,-3.65625 3.65625,-3.65625c2.01929,0 3.65625,1.63696 3.65625,3.65625c0,2.01929 -1.63696,3.65625 -3.65625,3.65625zM7.3125,20.09326c0,0 7.3125,-6.92981 7.3125,-12.1875c0,-4.03858 -3.27392,-7.3125 -7.3125,-7.3125c-4.03858,0 -7.3125,3.27392 -7.3125,7.3125c0,5.25769 7.3125,12.1875 7.3125,12.1875z",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.94e13051.svg";
export { ForwardRef as ReactComponent };